import React, { useEffect, useState } from 'react'
import 'bulma'
import './App.scss'
import "./App.css"

import Landing from './components/Landing'
import About from './components/About'
import Projects from './components/Projects'
import Contact from './components/Contact'

import { Routes, Route, useNavigate } from 'react-router-dom'
import { AnimatePresence } from "framer-motion";

import Fakeflix from './ProjectContainer/Fakeflix'
import Meadlight from './ProjectContainer/Meadlight'
import GoogleStories from './ProjectContainer/GoogleStories'
import Cambrian from './ProjectContainer/Cambrian'
import AirpodsPro from './ProjectContainer/AirpodsPro'

const WholePage = () => {

    const [display, setDisplay] = useState(true)

    function showContent() {
        setDisplay(true)
    }

    return (
        <>
            <Landing showContent={() => showContent()} />
            {
                display
                    ? (<>
                        <About />
                        <Projects />
                        <Contact />
                    </>)
                    : null
            }
        </>
    )
}

const App = () => {

    const [isFirstMount, setIsFirstMount] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const unlisten = navigate(() => {
            isFirstMount && setIsFirstMount(false);
        });

        return unlisten;
    }, [navigate, isFirstMount]);

    return (
        <div className="App">
            <AnimatePresence exitBeforeEnter>
                <Routes>
                    <Route path="/" element={<WholePage />} />
                    <Route path="/fakeflix" element={<Fakeflix isFirstMount={isFirstMount} />} />
                    <Route path="/meadlight" element={<Meadlight isFirstMount={isFirstMount} />} />
                    <Route path="/googlestories" element={<GoogleStories isFirstMount={isFirstMount} />} />
                    <Route path="/cambrian" element={<Cambrian isFirstMount={isFirstMount} />} />
                    <Route path="/airpodspro" element={<AirpodsPro isFirstMount={isFirstMount} />} />
                </Routes>
            </AnimatePresence>
        </div>

    )
}

export default App